import { RouteModule } from '#/horizon/components/RouteModule';

import { MovementPageLoadable } from './MovementPageLoadable';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { movementRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

export function loader(_: HorizonAppRouteLoaderArgs<typeof movementRoute>) {}

export default function MovementHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RouteModule
      title="Interest Form"
      linkRels={{ canonical: movementRoute.with({}) }}
    >
      <MovementPageLoadable />
    </RouteModule>
  );
}
